import type { ReactNode } from "react";

interface AdminPageTitleProps {
  /** 标题内容 */
  title: ReactNode;
  /** 副标题内容，存在时在标题后展示问号图标，悬浮才显示 */
  tooltip?: ReactNode;
  /** 额外的类名，附加到标题元素上 */
  className?: string;
}

/**
 * 后台页面统一标题组件。
 * 字号基准为 User & Permission 页面，副标题悬浮提示基准为 Document Category Management 页面。
 */
export default function AdminPageTitle({ title, tooltip, className }: AdminPageTitleProps) {
  return (
    <h2
      className={`text-xl font-semibold text-gray-900 flex items-center gap-1.5${
        className ? ` ${className}` : ""
      }`}
    >
      {title}
      {tooltip != null && tooltip !== "" && (
        <span className="relative group cursor-help">
          <i className="ri-question-line text-gray-400 text-sm w-4 h-4 flex items-center justify-center"></i>
          <span className="absolute top-full mt-1.5 left-1/2 -translate-x-1/2 hidden group-hover:block w-64 text-[11px] text-gray-600 bg-white border border-gray-200 rounded-md shadow-sm px-2.5 py-1.5 z-50 leading-relaxed">
            {tooltip}
          </span>
        </span>
      )}
    </h2>
  );
}
